<template>
  <div class="img-upload">
    <div v-if="!imgUrl" class="upload" @click="$refs.upload.click()"></div>
    <div v-else class="img-container">
      <img :src="imgUrl" alt="" />
      <div class="mask">
        <i class="el-icon-zoom-in" @click="handlePreview"></i>
        <i class="el-icon-delete" @click="clearFile"></i>
      </div>
    </div>
    <input
      ref="upload"
      type="file"
      style="display: none;"
      @change="handleChange"
      accept=".jpeg,.jpg,.png"
    />
    <div v-if="visible" @click.stop="visible = false" class="preview">
      <img :src="imgUrl" alt="" />
    </div>
  </div>
</template>

<script>
import { createImgUrl } from '@manage/utils/utils'
export default {
  props: {
    img: String,
    needTransform: {
      type: Boolean,
      default: true
    },
    limit: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      imgUrl: this.img && this.needTransform ? createImgUrl(this.img) : '',
      visible: false
    }
  },
  watch: {
    img(val) {
      this.imgUrl = val && this.needTransform ? createImgUrl(val) : val
    }
  },
  methods: {
    clearFile() {
      this.handleDelete()
      this.$emit('pickImg', '')
    },
    handleChange(e) {
      let file = e.target.files[0]
      if (file.size > this.limit * 1024 * 1024) {
        this.$refs.upload.value = null
        return this.$message.warning(`图片大小 ${this.limit} MB`)
      }
      if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
        this.$refs.upload.value = null
        return this.$message.warning(`图片格式只能为png、jpg、jpeg`)
      }
      if (file && this.imgUrl) {
        URL.revokeObjectURL(this.imgUrl)
      }
      this.imgUrl = URL.createObjectURL(file)
      this.$emit('pickImg', file)
    },
    handlePreview() {
      this.visible = true
    },
    handleDelete() {
      URL.revokeObjectURL(this.imgUrl)
      this.imgUrl = ''
      this.$refs.upload.value = null
    }
  }
}
</script>
<style lang="less">
@import url('../../styles/var.less');
.img-upload {
  .upload {
    width: 80px;
    height: 80px;
    border: 1px dashed #ccc;
    background: #f7f7f7;
    border-radius: 6px;
    cursor: pointer;
    line-height: 80px;
    text-align: center;
    &::after {
      content: '+';
      font-size: 40px;
      font-weight: 100;
      color: #ccc;
    }
  }
  .img-container {
    width: 80px;
    height: 80px;
    position: relative;
    border: 1px solid @borderColor;
    border-radius: 6px;
    overflow: hidden;
    .mask {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.5);
      opacity: 0;
      transition: opacity 0.3s;
      i {
        font-size: 20px;
        color: #fff;
        cursor: pointer;
      }
      .el-icon-delete {
        margin-left: 5px;
        &:hover {
          color: @red;
        }
      }
    }
    &:hover {
      .mask {
        opacity: 1;
      }
    }
    img {
      width: 80px;
      height: 80px;
      object-fit: cover;
    }
  }
  .preview {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 2001;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: auto;
  }
}
</style>
